export default __webpack_public_path__ + "assets/aad661806ec443297887f6c8cb6336ce.svg";